import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { PlantBadge, plantAlt, Section, Heading, Spinner, EmptyState } from "../components/Bits";
import PageHero from "../components/PageHero";

export default function Favorites() {
  const [plants, setPlants] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useAuth() || {};

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    api.get("/favorites").then((r) => setPlants(r.data || [])).finally(() => setLoading(false));
  }, [user]);

  if (!user) {
    return (
      <Section>
        <PageHero slug="favorites" variant="soft"
        defaultOverline="Merkliste"
        defaultTitle="Deine Favoriten"
        defaultSubtitle=""
      />
        <EmptyState title="Bitte anmelden" description="Speichere Pflanzen mit dem Herz-Symbol – sie erscheinen hier.">
          <Link to="/login" className="btn-primary">Zum Login</Link>
        </EmptyState>
      </Section>
    );
  }

  return (
    <>
      <PageHero slug="favorites" variant="soft"
        defaultOverline="Merkliste"
        defaultTitle="Deine gespeicherten Pflanzen"
        defaultSubtitle=""
      />
      <Section>
      {loading ? <Spinner /> : plants.length === 0 ? (
        <EmptyState title="Noch nichts gemerkt" description="Auf jeder Pflanzen-Detailseite findest du den Merken-Button." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="favorites-grid">
          {plants.map((p) => (
            <Link key={p.id} to={`/plants/${p.slug}`} className="plant-card block">
              <img src={p.image_url} alt={plantAlt(p)} loading="lazy" className="aspect-[4/3] w-full object-cover" />
              <div className="p-5">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="font-display text-xl">{p.name_de}</h3>
                  <PlantBadge category={p.category} />
                </div>
                <div className="italic text-xs opacity-70">{p.name_lat}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </Section>
    </>
  );
}
